const actions = {
  SET_STATE: 'user/SET_STATE',
  LOGIN: 'user/LOGIN',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  LOGOUT: 'user/LOGOUT',
  GET_USERS: 'user/GET_USERS',
  GET_ROLES: 'user/GET_ROLES',
  GET_SINGLEUSER: 'user/GET_SINGLEUSER',
  ENABLE_USER: 'user/ENABLE_USER',
  DISABLE_USER: 'user/DISABLE_USER',
  UPLOAD_CSV: 'user/UPLOAD_CSV',
  EDIT_USER: 'user/EDIT_USER',
  KICK_OUT_USER: 'user/KICK_OUT_USER',
  MULTI_DELETE_USER: 'user/MULTI_DELETE_USER',
  MULTI_DISABLE_USER: 'user/MULTI_DISABLE_USER',
  MULTI_KICKOUT_USER: 'user/MULTI_KICKOUT_USER',
  MULTI_ROLE_ASSIGN_OR_UNASSIGN_USER: 'user/MULTI_ROLE_ASSIGN_OR_UNASSIGN_USER',
}

export default actions
